import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { Fazenda } from 'src/app/classes/Fazenda';
import { Area } from 'src/app/classes/Area';
import { Setor } from 'src/app/classes/Setor';
import { LayerArea } from 'src/app/classes/LayerArea';
import { AreaService } from 'src/app/services/area.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forms-area',
  templateUrl: './forms-area.component.html',
  styleUrls: ['./forms-area.component.scss']
})
export class FormsAreaComponent implements OnInit {

  @Input() fazenda: Fazenda;
  @Input() organizaPorSetor: boolean = false;
  @Input() setoresIrrigado: Setor[] = [];
  @Input() setoresSequeiro: Setor[] = [];
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter();
  @Output() cancelar: EventEmitter<void> = new EventEmitter();
  @Output() atualizarSetores: EventEmitter<void> = new EventEmitter();

  @ViewChild('AreaModal', { static: false }) AreaModal: UiModalComponent;
  @ViewChild('formularioArea', { static: false }) formularioArea: NgForm;

  area: Area = new Area();
  layersArea: LayerArea[] = [];
  mostraMapa: boolean = false;
  editandoMapa: boolean = false;
  carregando: boolean = false;
  atualizandoSetores: boolean = false;
  isSubmit: boolean = false;

  // Traduções
  ERRO: string = 'Erro!';
  FEITO: string = 'Feito!';
  AREA_DELETADA: string = 'Área deletada';
  AREA_CADASTRADA: string = 'Área cadastrada!';
  AREA_ALTERADA: string = 'Área alterada!';

  constructor(
    private areaService: AreaService,
    private utils: UtilsService,
    private translate: TranslateService,
    private toasty: CustomToastyService,
    private router: Router
  ) {}

  ngOnInit() {
    this.configurarTraducao();
  }

  configurarTraducao() {
    this.ERRO = this.translate.instant('ERRO');
    this.FEITO = this.translate.instant('FEITO');
    this.AREA_DELETADA = this.translate.instant('AREA_DELETADA');
    this.AREA_CADASTRADA = this.translate.instant('AREA_CADASTRADA');
    this.AREA_ALTERADA = this.translate.instant('AREA_ALTERADA');
  }

  show(area?: Area, irrigado?: boolean) {
    if (area) {
      this.area = { ...area } as Area;
      this.layersArea = this.area.LayersArea ? JSON.parse(this.area.LayersArea) : [];
    } else {
      this.area = new Area();
      this.area.Ativo = true;
      this.layersArea = [];
      // Se irrigado foi especificado, definir a flag
      if (irrigado !== undefined) {
        this.area.Irrigado = irrigado;
      }
    }
    this.mostraMapa = true;
    this.isSubmit = false;
    this.AreaModal.show();
  }

  hide() {
    this.mostraMapa = false;
    this.resetarFormulario();
    this.AreaModal.hide();
  }

  resetarFormulario() {
    if (this.formularioArea) {
      this.formularioArea.resetForm();
    }
    this.area = new Area();
    this.layersArea = [];
    this.isSubmit = false;
  }

  alteraLayers(layers: string) {
    this.area.LayersArea = layers;
    this.layersArea = JSON.parse(layers);
  }

  checkBoxChange(opt: string) {
    switch (opt) {
      case 'Irrigado':
        this.area.Irrigado = true;
        this.area.Proprio = false;
        break;
      case 'Proprio':
        this.area.Proprio = true;
        this.area.Irrigado = false;
    }
  }

  saveArea(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }

    const permissaoNecessaria = this.area.Id > 0 ? 'EditarArea' : 'IncluirArea';
    if (!this.utils.verificarPermissaoUsuario(permissaoNecessaria)) {
      return;
    }

    this.carregando = true;
    this.configurarTraducao();
    this.area.FazendaId = this.fazenda.Id;

    if (this.area.Id > 0)
      this.areaService.putArea(this.area.Id, this.area).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.AREA_ALTERADA, 'success');
          this.carregando = false;
          this.mostraMapa = false;
          this.resetarFormulario();
          this.AreaModal.hide();
          this.finalizarSave.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
    else
      this.areaService.postArea(this.area).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.AREA_CADASTRADA, 'success');
          this.carregando = false;
          this.mostraMapa = false;
          this.resetarFormulario();
          this.AreaModal.hide();
          this.finalizarSave.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
  }

  cancelarArea() {
    this.mostraMapa = false;
    this.resetarFormulario();
    this.AreaModal.hide();
    this.cancelar.emit();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    );
  }

   abrirTelaSetor(): void {
    window.open('#/cadastros/setor', '_blank');
  }

  atualizarListaSetores(): void {
    this.atualizandoSetores = true;
    setTimeout(() => {
      this.atualizarSetores.emit();
      this.atualizandoSetores = false;
  }, 2000);
  }
}

